import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';  // Importer Helmet pour le SEO
import '../styles/Gallery.css'; // Importer le CSS global
import Modal from './Modal';  // Importer le composant Modal

const Gallery = () => {
  const [modalImage, setModalImage] = useState(null);  // État pour l'image du modal
  const [modalAltText, setModalAltText] = useState("");  // État pour le texte alternatif de l'image

  const openModal = (image, altText) => {
    setModalImage(image);
    setModalAltText(altText);
  };

  const closeModal = () => {
    setModalImage(null);
    setModalAltText("");
  };

  return (
    <div className="gallery">
      {/* Ajout des balises meta pour améliorer le SEO */}
      <Helmet>
        <title> Galerie des Albums - Les Z'ineuvitables</title>
        <meta name="description" content="Découvrez nos albums photos des spectacles passés et de nos événements. Explorez nos couvertures d'album et revivez chaque moment." />
        <meta property="og:title" content="Galerie des Albums - Les Z'ineuvitables" />
        <meta property="og:description" content="Découvrez nos albums photos des spectacles passés et de nos événements. Explorez nos couvertures d'album et revivez chaque moment." />
        <meta property="og:image" content="/cover-image.jpg" />
        <meta property="og:url" content="https://zineuvitables.org/galerie" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Galerie des Albums - Les Z'ineuvitables" />
        <meta name="twitter:description" content="Découvrez nos albums photos des spectacles passés et de nos événements." />
        <meta name="twitter:image" content="/cover-image.jpg" />
      </Helmet>

      <h1>📷 Galerie des Albums</h1>
      <div className="album-list">
             <div className="album-card">
          <Link to="/Portfolio">
            <img
              src="/album/portfolio/anonyme.png"
              alt="Couverture de l'album portfolio"
              className="album-cover"
              onClick={() => openModal('/album/portfolio/anonyme.png', "Couverture de l'album forum des associations")}
            />
            <h3>🌟Notre troupe🌟 </h3>
          </Link>
        </div>
                  <div className="album-card">
          <Link to="/album/Bistrotdesmagouilles">
            <img
              src="/album/lebistrotdesmagouilles/bistrot.jpg"
              alt="Couverture de l'album le bistrot des magouilles"
              className="album-cover"
              onClick={() => openModal('/album/lebistrotdesmagouilles/bistrot.jpg', "Couverture de l'album le bistrot des magouilles")}
            />
            <h3>Le bistrot des magouilles 💰</h3>
          </Link>
        </div>
            <div className="album-card">
          <Link to="/album/uneheure">
            <img
              src="/album/uneheure/Affiche une heure.jpg"
              alt="Couverture de l'album une heure d'avance"
              className="album-cover"
              onClick={() => openModal('/album/uneheure/Affiche une heure.jpg', "Couverture de l'album Coulisse 2024")}
            />
            <h3>Une heure d'avance⌛</h3>
          </Link>
        </div>
             <div className="album-card">
          <Link to="/album/retraite">
            <img
              src="/album/retraite/14juillet.jpg"
              alt="Couverture de l'album 14 juillet à la maison de retraite"
              className="album-cover"
              onClick={() => openModal('/album/retraite/juillet4.jpg', "Couverture de l'album 14 juillet à la maison de retraite")}
            />
            <h3>14 juillet à la maison de retraite 🎆</h3>
          </Link>
        </div>
               <div className="album-card">
          <Link to="/album/diva">
            <img
              src="/album/diva/affichediva.jpg"
              alt="Couverture de l'album Diva du sofa"
              className="album-cover"
              onClick={() => openModal('/album/diva/diva1.jpg', "Couverture de l'album diva")}
            />
            <h3>La diva du sofa 🎤 </h3>
          </Link>
        </div>
        <div className="album-card">
          <Link to="/album/complique">
            <img
              src="/album/complique/affiche-complique.jpg"
              alt="Couverture de l'album Complique"
              className="album-cover"
              onClick={() => openModal('/album/complique/complique10.jpg', "Couverture de l'album Complique")}
            />
            <h3>ça se complique 💥</h3>
          </Link>
        </div>
       <div className="album-card">
          <Link to="/album/malle">
            <img
              src="/album/onsefaitlamalle/affichemalle.jpg"
              alt="Couverture de l'album on se fait la malle"
              className="album-cover"
              onClick={() => openModal('/album/onsefaitlamalle/affichemalle.jpg', "Couverture de l'album Coulisse 2024")}
            />
            <h3>On se fait la malle 🚪</h3>
          </Link>
        </div>
 
        <div className="album-card">
          <Link to="/album/gorille">
            <img
              src="/album/gorille/7.jpg"
              alt="Couverture de l'album gare au gorille"
              className="album-cover"
              onClick={() => openModal('/album/gorille/gorille12.jpg', "Couverture de l'album Coulisse 2024")}
            />
            <h3>Gare au gorille 🦍</h3>
          </Link>
        </div>
        <div className="album-card">
          <Link to="/album/logequipeut">
            <img
              src="/album/logequipeut/1.jpg"
              alt="Couverture de l'album loge qui peut"
              className="album-cover"
              onClick={() => openModal('/album/logequipeut/loge4.jpg', "Couverture de l'album loge qui peut")}
            />
            <h3>Loge qui peut 🏠</h3>
          </Link>
        </div>
      <div className="album-card">
          <Link to="/album/coulisse2024">
            <img
              src="/album/coulisse2024/coulisse1.jpg"
              alt="Couverture de l'album Coulisse 2024"
              className="album-cover"
              onClick={() => openModal('/album/coulisse2024/coulisse1.jpg', "Couverture de l'album Coulisse 2024")}
            />
            <h3>Coulisse 2024</h3>
          </Link>
        </div>
        <div className="album-card">
          <Link to="/album/Salonasso">
            <img
              src="/album/salonasso/salon2.jpg"
              alt="Couverture de l'album forum des associations"
              className="album-cover"
              onClick={() => openModal('/album/salonasso/salon2.jpg', "Couverture de l'album forum des associations")}
            />
            <h3>Forum des associations</h3>
          </Link>
        </div>
      
        {/* Ajoute d'autres albums ici */}
      </div>

      {/* Affichage du Modal lorsque l'image est cliquée */}
      {modalImage && <Modal image={modalImage} altText={modalAltText} onClose={closeModal} />}
    </div>
  );
};

export default Gallery;
